var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF02",
    strokeDasharray: 7,
    strokeWidth: 6.99,
    d: "M48.78 38.68c283.78 121.96 193.89 315.49 193.89 315.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF02",
    d: "M27.45 48.8c-9.83 0-18.28-6.69-20.53-16.28a20.982 20.982 0 0 1 2.6-15.95c2.97-4.79 7.62-8.15 13.11-9.44 1.59-.38 3.23-.57 4.85-.57 9.83 0 18.27 6.69 20.53 16.28 1.29 5.49.37 11.15-2.6 15.94-2.97 4.79-7.62 8.15-13.11 9.44-1.59.38-3.23.57-4.85.57v.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34);
export default __webpack_public_path__ + "static/media/34.918669e41059a6b91cbf49626d813911.svg";
export { ForwardRef as ReactComponent };